import { useEffect } from "react";

export default function useOnClickOutside(ref, handler) {
  useEffect(() => {
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      const allModals = Array.from(document.querySelectorAll('[role="dialog"]'));

      const topModal = allModals[allModals.length - 1];
      const topPanel = topModal?.querySelector(".pointer-events-auto");

      if (topPanel && !ref.current.isSameNode(topPanel)) {
        return;
      }

      handler(event);
    };

    document.addEventListener("mousedown", listener, true);

    return () => {
      document.removeEventListener("mousedown", listener, true);
    };
  }, [ref, handler]);
}
